export const MESSAGES = {
  SUCCESS: 'Success',
  SAVE_DATA: 'Data saved successfully',
  NODE_REMOVE: 'Node removed successfully',
  DELETE_NODE: 'Are you sure you want to delete the node ',
  UNSAVED_CHANGES: 'There are some unsaved changes. Please save it.',
};
